import type { TFunction } from "i18next"
import type { IInboundOrderItem } from "../../apis/inbound-order"

/**
 * Item name for an inbound line. The backend stores a name only for uncatalogued items; a catalogued
 * line carries just a product id, which is never shown: use the SKU, else a neutral label.
 */
export function inboundItemLabel(item: Pick<IInboundOrderItem, "uncataloguedItemName" | "uncataloguedSku">, t: TFunction): string {
  return item.uncataloguedItemName || item.uncataloguedSku || t("inbound:detail.catalogItem")
}
